var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ds-note",class:_vm.variant,attrs:{"role":_vm.live,"aria-live":_vm.live === 'alert' ? 'assertive' : (_vm.live ? 'polite' : null),"aria-atomic":_vm.live ? 'true' : null}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }